import { Outlet } from 'react-router-dom'
import { Footer } from './footer'
import { Header } from './header'

export function MainLayout() {
  return (
    <div className="relative flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}

export function MainLayoutNoFooter() {
  return (
    <div className="relative flex h-screen flex-col">
      <Header />
      <Outlet />
    </div>
  )
}
